import React from 'react';
import { Button } from './ui/button';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16 grid md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                <span className="text-slate-900 font-bold text-sm">AI</span>
              </div>
              <span className="text-xl font-bold">Agents.audio</span>
            </div>
            <p className="text-gray-300 leading-relaxed">
              Empowering healthcare professionals with AI-powered automation for patient management 
              and communication. Trusted by healthcare practices nationwide.
            </p>
            {/* <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div> */}
          </div>
          
          
          {/* Contact */}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold">Contact</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-emerald-400" />
                <span className="text-gray-300">sales@agents.audio</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-emerald-400" />
                <span className="text-gray-300">+1(855)560-3920</span>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-emerald-400 mt-0.5" />
                <span className="text-gray-300">SE 8th Street<br />Bellevue, WA 98007</span>
              </div>
            </div>
            
          </div>
        </div>
        
        {/* CTA Section
        <div className="py-12 border-t border-gray-800">
          <div className="text-center space-y-6">
            <h3 className="text-2xl font-bold">Ready to Transform Your Practice?</h3>
            <p className="text-gray-300 max-w-2xl mx-auto">
              Join hundreds of chiropractic professionals who are already saving time and improving 
              patient satisfaction with Agents.audio AI.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                size="lg" 
                className="bg-white hover:bg-gray-100 text-slate-900 px-8 font-medium"
              >
                Start Free Trial
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="border-gray-600 text-gray-300 hover:bg-gray-800 hover:text-white px-8 font-medium"
              >
                Contact Sales
              </Button>
            </div>
          </div>
        </div> */}
        
        {/* Bottom Bar */}
        <div className="py-6 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-gray-400 text-sm">
            © 2025 Agents.audio. All rights reserved.
          </div>
            <div className="flex space-x-6 text-sm">
            <Link to="/b/" target="_blank" className="text-gray-400 hover:text-white transition-colors">Blog</Link>
            <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};